import { Injectable } from '@angular/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Action, Store } from '@ngrx/store';
import * as fromBase from '../reducers';
import * as preferences from '../actions/preferences.actions'
import * as product from '../../catalog/actions/product'
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap, tap, filter } from 'rxjs/operators';
import { PreferencesService } from '../services/preferences.service';
import { AnalyticsService } from '../../shared/services/analytics.service';

@Injectable()
export class PreferencesEffects {
  constructor(
    private actions$: Actions,
    private preferencesSvc: PreferencesService,
    private analyticsSvc: AnalyticsService,
  ) {}

  @Effect()
  getPreferencesOnStart$: Observable<Action> =
    this.actions$.ofType<preferences.GetTenantPreferences>(preferences.GET_TENANT_SETTINGS)
      .pipe(
        switchMap(action => {
          return this.preferencesSvc.getTenantSpecificPreferences()
            .pipe(
              map(settings => new preferences.GetTenantPreferencesSuccess(settings)),
              catchError(e => of(new preferences.GetTenantPreferencesFailed(e)))
            )
        })
      )

  // @Effect()
  // setDefaultCatalogSortOrder$: Observable<Action> = this.actions$.pipe(
  //   ofType<preferences.GetTenantPreferencesSuccess>(preferences.GET_TENANT_SETTINGS_SUCCESS),
  //   map((action) => {
  //     const catalogSortOrders = action.payload.find(setting => setting.key === 'catalog_sort_orders')
  //     if (catalogSortOrders && catalogSortOrders.value && catalogSortOrders.value.length) {
  //       const defaultSortOrder = catalogSortOrders.value[0].key
  //       return new product.SetProductDefaultSortOrderSuccess(defaultSortOrder)
  //     }
  //   })
  // )

  @Effect({ dispatch: false })
  getTenantPreferencesSuccess$ = this.actions$.pipe(
    ofType<preferences.GetTenantPreferencesSuccess>(preferences.GET_TENANT_SETTINGS_SUCCESS),
    map((action) => {
      const trackingId = action.payload.find(setting => setting.key === 'ga_tracking_id');
      if (trackingId && trackingId.value) {
        return trackingId.value
      }

      return ''
    }),
    filter((trackingId) => !!trackingId),
    tap((trackingId) => this.analyticsSvc.init(trackingId))
  )
}
